import React from 'react';
import { observer } from 'mobx-react';
import { Radio } from 'core/components/radio';
import { Label } from 'core/components/label';
import { useStore } from 'core/store';
import useCheckoutContextGenerator from 'offer/components/checkout/hooks/use-checkout-context-generator';
import useSweepAccount from 'offer/components/checkout/components/sweep-bind-option/use-sweep-account';
import useStyles from './purchase-choices.styles';

const PurchaseChoices = observer(() => {
  const classes = useStyles();
  const { offer: store } = useStore();
  const { canChooseDirectPurchase, purchaseChoice } = useCheckoutContextGenerator();
  const { sweepAccount } = useSweepAccount(store.offer);
  const hasSweep = canChooseDirectPurchase && sweepAccount?.paymentMethods?.length > 0;
  const options = [
    ...(canChooseDirectPurchase ? [{ value: 'purchase', label: 'Purchase now' }] : []),
    { value: 'link', label: 'Send a purchase link' },
    ...(hasSweep ? [{ value: 'sweep', label: 'Charge the agency sweep account' }] : [])
  ];
  let hint = 'Review payment details and complete the purchase at checkout.';
  if (purchaseChoice === 'link') {
    hint = 'Continue to checkout to review the details and send the link.';
  } else if (purchaseChoice === 'sweep' && hasSweep) {
    hint =
      "The sweep account covers the initial payment. Add the customer's payment method for future installments at checkout.";
  }
  return (
    <div className={classes.container}>
      <Radio
        id="quote-purchase-choice"
        name="quote-purchase-choice"
        aria-label="How to pay"
        optionsSideBySide={false}
        options={options}
        value={purchaseChoice === 'sweep' && !hasSweep ? 'purchase' : purchaseChoice}
        onChange={(event) => store.setQuotePurchaseChoice(event.target.value)}
      />
      <Label type="body2" className={classes.hint}>
        {hint}
      </Label>
    </div>
  );
});
export default PurchaseChoices;
